
import React, { useCallback } from 'react';
import styles from "./index.module.scss";
import iSafe from "@/modules/tm/assets/detail/safe-shield.png";

const TMDetailTransferData: React.FC = (props) => {


  // 信息列创建
  const createInfoRow = useCallback(
    (title: string, values: string[], width?: number, ) => {
      return <div style={{width: width, height: 270, flex: width === undefined ? 1 : undefined}} className={`flex-col`}>
        <div style={{height: 70}} className={`${styles.title} flex-row-center`}>{title}</div>
        {values.map((item, index) => {
          return <div key={index} className={`${styles.value} flex-row-center`}>
            {item}
          </div>
        })}
      </div>
    },
    [],
  )

  return (
    <div className={styles.container}>
      <div className={`${styles.header} flex-row flex-cross-axis-center flex-main-axis-between`}>
        <h2>过户资料</h2>
        <div className="flex-row flex-cross-axis-center">
          <img className={styles.icon} src={iSafe} alt="" />
          <div className={styles.notice}>资料齐全，真实可靠，保障交易安全</div>
        </div>
      </div>
      <hr />
      <div className={styles.content}> 
        <div className="flex-row">
          {createInfoRow("主体资料", ["自然人", "企业"], 132)}
          {createInfoRow("受让方提供", ["身份证\n个体户营业执照", "企业营业执照"], 180)}
          {createInfoRow("转让方提供", ["身份证“正反”两面复印件\n商标注册证原件", "企业营业执照\n商标注册证原件"], 234)}
          {createInfoRow("平台提供", ["转让申请书\n代理委托书\n转让协议书\n商标使用授权书"], 234)}
          {createInfoRow("过户后，受让方可获得官方证件", ["商标注册证原件\n商标转让受理回执\n商标转让证明"])}
        </div>
        <div className={styles.notice}>
        {"以上资料均须提供电子档，转让注册商标，3-7个工作日左右办理好转让手续，获得\"商标使用授权书\"即日可以打R使用，安全无风险。\n转让注册商标经核准后，予以公告。受让人自公告之日起享有商标专用权。"}
        </div>
      </div>
    </div>
  )
}

export default TMDetailTransferData;
